// @flow

// Originally copied from segmentio/analytics-next library (MIT licensed)
// https://github.com/segmentio/analytics-next/blob/b7d8563e461fb5aac6a2e517a537e89bd0f9fa45/packages/core/src/callback/index.ts#L4C1-L17C2
function pTimeout<T>(promise: Promise<T>, timeout: number): Promise<T> {
  return new Promise((resolve, reject) => {
    const timeoutId = setTimeout(() => {
      reject(Error('Promise timed out'));
    }, timeout);

    promise
      .then(val => {
        clearTimeout(timeoutId);
        return resolve(val);
      })
      .catch(reject);
  });
}

// Originally copied from segmentio/analytics-next library (MIT licensed)
// https://github.com/segmentio/analytics-next/blob/b7d8563e461fb5aac6a2e517a537e89bd0f9fa45/packages/browser/src/core/auto-track.ts#L5-L96
type JQueryShim = {
  toArray(): Array<HTMLElement>,
  ...
};

type EventProperties = Record<string, any>;

export function trackLink(
  track: (event: string, props: { ... }) => Promise<any>,
  links: HTMLElement | Array<HTMLElement> | JQueryShim | null,
  event: string | (HTMLElement => string),
  properties: EventProperties | (HTMLElement => EventProperties)
) {
  let elements: Array<HTMLElement> = [];
  if (!links) return;

  // always arrays, handles jquery
  if (links instanceof HTMLElement) {
    elements = [links];
  } else if (links instanceof Array) {
    elements = links;
  } else if ('toArray' in links) {
    elements = links.toArray();
  }

  elements.forEach((el: HTMLElement) => {
    el.addEventListener(
      'click',
      (elementEvent: Event) => {
        const ev = typeof event === 'function' ? event(el) : event;
        const props =
          typeof properties === 'function' ? properties(el) : properties;
        const href =
          el.getAttribute('href') ||
          el.getAttributeNS('http://www.w3.org/1999/xlink', 'href') ||
          el.getAttribute('xlink:href') ||
          // flowlint-next-line unnecessary-optional-chain:off
          el.getElementsByTagName('a')[0]?.getAttribute('href');

        const trackEvent = pTimeout(
          track(ev, props),
          // this.settings.timeout ?? 500
          500
        );

        if (
          !linkNewTab(
            // $FlowIgnore[incompatible-cast] -- Cast is copied over from the original source code
            (el: HTMLAnchorElement),
            href
          ) &&
          !userNewTab(elementEvent)
        ) {
          if (href) {
            elementEvent.preventDefault();
            trackEvent
              // eslint-disable-next-line no-console
              .catch(console.error)
              .then(() => {
                window.location.href = href;
              })
              // eslint-disable-next-line no-console
              .catch(console.error);
          }
        }
      },
      false
    );
  });
}

// Check if a user is opening the link in a new tab
function userNewTab(event: Event): boolean {
  const typedEvent: Event | KeyboardEvent | MouseEvent = event;
  if (
    typedEvent.ctrlKey ||
    typedEvent.shiftKey ||
    typedEvent.metaKey ||
    // flowlint-next-line sketchy-number-and:off
    (typedEvent.button && typedEvent.button === 1)
  ) {
    return true;
  }
  return false;
}

// Check if the link opens in new tab
function linkNewTab(
  element: HTMLAnchorElement,
  href: string | null | void
): boolean {
  if (element.target === '_blank' && href) {
    return true;
  }
  return false;
}
